import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Link } from 'react-router-dom';
import PRODUCTS from './util/mock-products';
import { collection, getDocs } from "firebase/firestore";
import { db1 } from "./firebase/firebase1";
import { query, where } from "firebase/firestore";
import Api from "./admin/cmp/api/api";

export default function Home({ contactInfo }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const year = new Date().getFullYear();

  const [featuredProducts, setFeaturedProducts] = useState([]);
  useEffect(() => {
    const fetchFeatured = async () => {
      try {
        const q = query(collection(db1, "our_products"), where("featured", "==", 1));
        const querySnapshot = await getDocs(q);
        const featured = [];
        querySnapshot.forEach((doc) => {
          featured.push({ id: doc.id, ...doc.data() });
        })
        // Optionally limit to first few
        setFeaturedProducts(featured.slice(0, 4));
      } catch (err) {
        console.error("Error fetching featured products:", err);
      }
    }
    fetchFeatured()
  }, [])

  useEffect(() => {
    document.title = "Patient Choice — Medical & Wellness Supplies";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "Patient Choice: OTC meds, orthopedic supports, wound care, mobility aids, diagnostics and more. Shop reliable medical supplies for home and clinic."
      );
    } else {
      const m = document.createElement("meta");
      m.name = "description";
      m.content =
        "Patient Choice: OTC meds, orthopedic supports, wound care, mobility aids, diagnostics and more. Shop reliable medical supplies for home and clinic.";
      document.head.appendChild(m);
    }
  }, []);

  function handleSubmit(e) {
    e.preventDefault();
    const obj = {
      name: e.target.name.value,
      contact: e.target.contact.value,
      message: e.target.message.value
    };
    Api.sendContactUsEmail(obj);
    // Optional: reset form
    e.target.reset();
  }


  // helper: get numeric price (fallback to first variant)
  function getNumericPrice(item) {
    if (!item) return null;
    return item.price
    // if (typeof item.price === "number") return item.price;
    // const v = item.variants && item.variants[0];
    // if (v && typeof v.price === "number") return v.price;
    // return null;
  }


  return (
    <div>
      {/* Embedded original stylesheet to keep the page exactly like the provided HTML */}

      <main>
        <section className="container hero" style={{ paddingLeft: 60, paddingRight: 60 }}>
          <div>
            <div className="kicker" style={{ backgroundColor: '#fff', color: '#16a34a' }}>Community-first medical supply</div>
            <h1>Trusted supplies for home & clinic — fast, local, and affordable.</h1>
            <p className="lead">From <strong>OTC medicines</strong> and <strong>orthopedic supports</strong> to <strong>wound care</strong>, <strong>mobility aids</strong>, and <strong>diagnostics</strong>, Patient Choice keeps your essentials in stock with caring guidance.</p>

            <div className="actions">
              <a className="btn" href="#categories" style={{ backgroundColor: 'white', color: 'black' }}>Shop categories</a>
              <a className="btn" href="#featured" style={{ borderColor: 'white' }}><span className="dot" style={{ backgroundColor: 'white' }} aria-hidden="true"></span> See featured items</a>
            </div>

            <div className="trust">
              <span className="chip" style={{ color: 'white', display: 'inline-flex', gap: '.5rem', alignItems: 'center' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" style={{ flexShrink: 0 }}>
                  <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Pharmacist-advised OTC
              </span>
              <span className="chip" style={{ color: 'white', display: 'inline-flex', gap: '.5rem', alignItems: 'center' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" style={{ flexShrink: 0 }}>
                  <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Genuine, clinic-grade brands
              </span>
              <span className="chip" style={{ color: 'white', display: 'inline-flex', gap: '.5rem', alignItems: 'center' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" style={{ flexShrink: 0 }}>
                  <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Local pickup & delivery
              </span>
              <span className="chip" style={{ color: 'white', display: 'inline-flex', gap: '.5rem', alignItems: 'center' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" style={{ flexShrink: 0 }}>
                  <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Secure payments
              </span>
            </div>
          </div>

          <div className="hero-card" aria-label="Top categories">
            <div className="hero-grid">
              <Link className="category" to="/category/otc">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 2v20M4 10h16" /></svg>
                <div>
                  <strong>OTC Medicines</strong>
                  <div className="subtle">Pain, cold & flu, GI, allergy</div>
                </div>
              </Link>

              <Link className="category" to="/category/orthopedic">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M7 3h10v6H7zM9 9v12M15 9v12" /></svg>
                <div>
                  <strong>Orthopedic Supports</strong>
                  <div className="subtle">Back, knee, wrist, ankle</div>
                </div>
              </Link>

              <Link className="category" to="/category/wound">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="7" width="18" height="10" rx="3" /><circle cx="9" cy="12" r="1" /><circle cx="12" cy="12" r="1" /><circle cx="15" cy="12" r="1" /></svg>
                <div>
                  <strong>Wound Care</strong>
                  <div className="subtle">Dressings, tapes, antiseptics</div>
                </div>
              </Link>

              <Link className="category" to="/category/mobility">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="7" cy="17" r="3" /><circle cx="17" cy="17" r="3" /><path d="M7 17h5l2-5h4" /></svg>
                <div>
                  <strong>Mobility Aids</strong>
                  <div className="subtle">Canes, walkers, wheelchairs</div>
                </div>
              </Link>

            </div>

            <div className="actions" style={{ marginTop: '.9rem' }}>
              <Link className="btn" to="/category/diagnostics">Diagnostics</Link>
              <Link className="btn" to="/category/respiratory">Respiratory</Link>
              <Link className="btn" to="/category/incontinence">Incontinence</Link>
              <Link className="btn" to="/category/personal">Personal Care</Link>
            </div>
          </div>
        </section>

        <section id="categories" className="section container">
          <h2>Browse categories</h2>
          <div className="grid">
            <Link className="card" to="/category/otc">
              <div className="thumb" role="img" aria-label="OTC medicines">
                <img
                  src={require('../assets/otc.png')}
                  alt="OTC medicines"
                  style={{ borderBottom: '1px solid lightgray', width: '100%', height: '100%', objectFit: 'cover', borderTopLeftRadius: 12, borderTopRightRadius: 12 }}
                />
              </div>
              <div className="body"><strong id="otc">OTC Medicines</strong><div className="subtle">Pain relief, cold & flu, allergy, GI, vitamins</div></div>
            </Link>

            <Link className="card" to="/category/orthopedic">
              <div className="thumb" role="img" aria-label="OTC medicines">
                <img
                  src={require('../assets/foot1.jpg')}
                  alt="OTC medicines"
                  style={{ borderBottom: '1px solid lightgray', width: '100%', height: '100%', objectFit: 'cover', borderTopLeftRadius: 12, borderTopRightRadius: 12 }}
                />
              </div>
              <div className="body"><strong id="ortho">Orthopedic Supports</strong><div className="subtle">Braces for knee, back, wrist, ankle</div></div>
            </Link>

            <Link className="card" to="/category/wound">
              <div className="thumb" role="img" aria-label="OTC medicines">
                <img
                  src={require('../assets/wound.jpeg')}
                  alt="OTC medicines"
                  style={{ borderBottom: '1px solid lightgray', width: '100%', height: '100%', objectFit: 'cover', borderTopLeftRadius: 12, borderTopRightRadius: 12 }}
                />
              </div>
              <div className="body"><strong id="wound">Wound Care</strong><div className="subtle">Gauze, dressings, adhesive, cleansers</div></div>
            </Link>

            <Link className="card" to="/category/mobility">
              <div className="thumb" role="img" aria-label="OTC medicines">
                <img
                  src={require('../assets/mobility.jpeg')}
                  alt="OTC medicines"
                  style={{ borderBottom: '1px solid lightgray', width: '100%', height: '100%', objectFit: 'cover', borderTopLeftRadius: 12, borderTopRightRadius: 12 }}
                />
              </div>
              <div className="body"><strong id="mobility">Mobility Aids</strong><div className="subtle">Canes, walkers, wheelchairs</div></div>
            </Link>

            <Link className="card" to="/category/diagnostics">
              <div className="thumb" role="img" aria-label="OTC medicines">
                <img
                  src={require('../assets/diagnostics2.jpg')}
                  alt="OTC medicines"
                  style={{ borderBottom: '1px solid lightgray', width: '100%', height: '100%', objectFit: 'cover', borderTopLeftRadius: 12, borderTopRightRadius: 12 }}
                />
              </div>
              <div className="body"><strong id="diagnostics">Diagnostics</strong><div className="subtle">BP monitors, glucose meters, thermometers</div></div>
            </Link>

            <Link className="card" to="/category/respiratory">
              <div className="thumb" role="img" aria-label="OTC medicines">
                <img
                  src={require('../assets/neb.jpg')}
                  alt="OTC medicines"
                  style={{ borderBottom: '1px solid lightgray', width: '100%', height: '100%', objectFit: 'cover', borderTopLeftRadius: 12, borderTopRightRadius: 12 }}
                />
              </div>
              <div className="body"><strong id="respiratory">Respiratory</strong><div className="subtle">Nebulizers, spacers, pulse oximeters</div></div>
            </Link>

            <Link className="card" to="/category/incontinence">
              <div className="thumb" role="img" aria-label="OTC medicines">
                <img
                  src={require('../assets/pads.jpg')}
                  alt="OTC medicines"
                  style={{ borderBottom: '1px solid lightgray', width: '100%', height: '100%', objectFit: 'cover', borderTopLeftRadius: 12, borderTopRightRadius: 12 }}
                />
              </div>
              <div className="body"><strong id="incontinence">Incontinence</strong><div className="subtle">Briefs, pads, skin care</div></div>
            </Link>

            <Link className="card" to="/category/personal">
              <div className="thumb" role="img" aria-label="OTC medicines">
                <img
                  src={require('../assets/care.jpg')}
                  alt="OTC medicines"
                  style={{ borderBottom: '1px solid lightgray', width: '100%', height: '100%', objectFit: 'cover', borderTopLeftRadius: 12, borderTopRightRadius: 12 }}
                />
              </div>
              <div className="body"><strong id="personal">Personal Care</strong><div className="subtle">Hygiene, skincare, daily wellness</div></div>
            </Link>

            <Link className="card" to="/category/others">
              <div className="thumb" role="img" aria-label="Others">
                <img
                  src={require('../assets/other.jpeg')}
                  style={{ borderBottom: '1px solid lightgray', width: '100%', height: '100%', objectFit: 'cover', borderTopLeftRadius: 12, borderTopRightRadius: 12 }}
                />
              </div>
              <div className="body"><strong id="personal">Other</strong><div className="subtle">Other necessary products</div></div>
            </Link>

          </div>
        </section>

        <section id="featured" className="section container">
          <h2>Featured essentials</h2>
          <div className="grid">
            {
              featuredProducts.map((p) => {
                const price = getNumericPrice(p);
                const img = (p.images && p.images.length) ? p.images[0] : (p.image || "");
                return (
                  <article className="card" key={p.id}>
                    <div className="thumb"
                      style={{
                        width: "100%",
                        height: "200px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "color-mix(in oklab, var(--surface) 90%, transparent)",
                        borderRadius: "12px",
                        overflow: "hidden",
                      }}
                      aria-label={p.title}>
                      {img ? (
                        <img src={img} alt={p.title} style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
                      ) : (
                        <svg viewBox="0 0 24 24"><rect x="3" y="3" width="12" height="10" rx="2" stroke="currentColor" strokeWidth="1.5" fill="none" /><path d="M15 8h3a3 3 0 0 1 3 3v6" stroke="currentColor" strokeWidth="1.5" fill="none" /></svg>
                      )}
                    </div>
                    <div className="body" style={{ flex: 1 }}>
                      <div><strong>{p.title}</strong></div>
                      <div className="subtle">{p.brand}</div>
                      <div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'space-between', marginTop: '.6rem' }}>
                        <span className="price">${price}</span>
                        <Link to={`/product/${p.id}`} className="btn pill sm">View</Link>
                      </div>
                    </div>
                  </article>
                )
              })}
          </div>
        </section>

        <section id="services" className="section container cards-row" aria-label="Services and benefits">
          <div className="callout">
            <h2>We’ll help you choose the right item</h2>
            <p className="subtle">Not sure which brace size or dressing type? Our team guides you to safe, effective options tailored to your needs.</p>
            <ul className="list">
              <li>
                <svg viewBox="0 0 20 20" fill="none" stroke="currentColor"><path d="M3 10l4 4 10-10" /></svg>
                <span><strong>Clinic-grade selection</strong> across orthopedics, wound care, respiratory, and diagnostics.</span>
              </li>
              <li>
                <svg viewBox="0 0 20 20" fill="none" stroke="currentColor"><path d="M3 10l4 4 10-10" /></svg>
                <span><strong>Local pickup & delivery</strong> in Pointe Michel · Roseau · environs.</span>
              </li>
              <li>
                <svg viewBox="0 0 20 20" fill="none" stroke="currentColor"><path d="M3 10l4 4 10-10" /></svg>
                <span><strong>Bulk/clinic orders</strong> with invoice support for practices and organizations.</span>
              </li>
            </ul>
            <div className="actions" style={{ marginTop: '1rem' }}>
              <a className="btn primary" href="#contact">Contact us</a>
              <a className="btn" href="#featured">See popular items</a>
            </div>
          </div>

          <div className="card" aria-label="Trust and hours">
            <div className="body">
              <h3 style={{ margin: '.4rem 0' }}>Why Patient Choice?</h3>
              <div className="subtle">Authentic brands · Friendly service · Fair prices</div>
              <div className="list" style={{ marginTop: '1rem' }}>
                <li><svg viewBox="0 0 20 20" fill="none" stroke="currentColor"><path d="M3 10l4 4 10-10" /></svg> Registered business in Dominica</li>
                <li><svg viewBox="0 0 20 20" fill="none" stroke="currentColor"><path d="M3 10l4 4 10-10" /></svg> Secure cash & card options</li>
                <li><svg viewBox="0 0 20 20" fill="none" stroke="currentColor"><path d="M3 10l4 4 10-10" /></svg> Easy returns on unopened items (7 days)</li>
              </div>
              <hr style={{ border: 'none', borderTop: '1px solid color-mix(in oklab, var(--muted) 25%, transparent)', margin: '1.1rem 0' }} />
              <h4 style={{ margin: '.2rem 0' }}>Hours</h4>
              <div className="subtle">{contactInfo.timing}</div>
              <h4 style={{ margin: '.9rem 0 .2rem' }}>Visit</h4>
              <div className="subtle">{contactInfo.address}</div>
              <h4 style={{ margin: '.9rem 0 .2rem' }}>Call/WhatsApp</h4>
              <div className="subtle">{contactInfo.phone}</div>
            </div>
          </div>
        </section>

        <section className="section container">
          <h2>What people say</h2>
          <div className="grid">
            <div className="card"><div className="body"><strong>“Super helpful team.”</strong><div className="subtle">They fitted my mom for the right knee brace and delivered the same day.</div></div></div>
            <div className="card"><div className="body"><strong>“Clinic-grade quality.”</strong><div className="subtle">Reliable BP monitor and accessories at a fair price—works great.</div></div></div>
            <div className="card"><div className="body"><strong>“One stop shop.”</strong><div className="subtle">From dressings to a walker—everything we needed in one place.</div></div></div>
            <div className="card"><div className="body"><strong>“Easy ordering.”</strong><div className="subtle">WhatsApp to confirm stock and pickup—so convenient.</div></div></div>
          </div>
        </section>

        <section id="contact" className="section container">
          <h2>Get in touch</h2>
          <div className="cards-row">
            <form className="card" onSubmit={handleSubmit} aria-label="Contact form">
              <div className="body">
                <label className="subtle" htmlFor="name">Name</label>
                <input id="name" required name="name" placeholder="Your name" style={{ width: '100%', padding: '.75rem 1rem', borderRadius: '12px', border: '1px solid color-mix(in oklab, var(--muted) 25%, transparent)', background: 'var(--surface)', color: 'var(--text)', margin: '.35rem 0 .8rem' }} />

                <label className="subtle" htmlFor="contactField">Email or WhatsApp</label>
                <input id="contactField" required name="contact" placeholder="you@example.com or +1 767…" style={{ width: '100%', padding: '.75rem 1rem', borderRadius: '12px', border: '1px solid color-mix(in oklab, var(--muted) 25%, transparent)', background: 'var(--surface)', color: 'var(--text)', margin: '.35rem 0 .8rem' }} />

                <label className="subtle" htmlFor="msg">Message</label>
                <textarea id="msg" rows={4} name="message" placeholder="Tell us what you need (e.g., knee brace size L, hydrocolloid dressings)…" style={{ width: '100%', padding: '.75rem 1rem', borderRadius: '12px', border: '1px solid color-mix(in oklab, var(--muted) 25%, transparent)', background: 'var(--surface)', color: 'var(--text)', margin: '.35rem 0 1rem' }} />

                <button className="btn primary" type="submit">Send message</button>
              </div>
            </form>

            <div className="callout">
              <h3 style={{ margin: '.2rem 0' }}>Wholesale & Clinics</h3>
              <p className="subtle">Need bulk pricing or monthly supply plans for your practice? We can help.</p>
              <ul className="list">
                <li><svg viewBox="0 0 20 20" fill="none" stroke="currentColor"><path d="M3 10l4 4 10-10" /></svg> Custom quotes & invoices</li>
                <li><svg viewBox="0 0 20 20" fill="none" stroke="currentColor"><path d="M3 10l4 4 10-10" /></svg> Scheduled deliveries</li>
                <li><svg viewBox="0 0 20 20" fill="none" stroke="currentColor"><path d="M3 10l4 4 10-10" /></svg> Priority stock reservations</li>
              </ul>
              <div className="actions" style={{ marginTop: '1rem' }}>
                <a className="btn" href="#featured">Browse essentials</a>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* <footer>
        <div className="container foot-grid">
          <div>
            <div className="logo" style={{ marginBottom: '.6rem' }}>
              <svg viewBox="0 0 48 48" aria-hidden="true" fill="none">
                <defs><linearGradient id="g2" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="var(--brand-2)" /><stop offset="1" stopColor="var(--brand)" /></linearGradient></defs>
                <path d="M24 41s-9.5-6.9-15.3-12.7C4.6 24.2 5 16.6 10 13.2a8.5 8.5 0 0 1 10 .6l4 3.2 4-3.2a8.5 8.5 0 0 1 10-.6c5.1 3.4 5.4 11-.7 15.1C33.5 34.1 24 41 24 41Z" stroke="url(#g2)" strokeWidth="2.5" fill="none" />
                <path d="M22.5 23h-4v-4h-3v4h-4v3h4v4h3v-4h4z" fill="url(#g2)" />
              </svg>
              <strong>PATIENT CHOICE</strong>
            </div>
            <div className="subtle">Healthcare & wellness supplies for Dominica. Genuine products, friendly guidance, and fast local delivery.</div>
          </div>

          <div>
            <strong>Shop</strong>
            <div className="list" style={{ marginTop: '.6rem' }}>
              <a href="#otc">OTC Medicines</a>
              <a href="#ortho">Orthopedic Supports</a>
              <a href="#wound">Wound Care</a>
              <a href="#mobility">Mobility Aids</a>
              <a href="#diagnostics">Diagnostics</a>
            </div>
          </div>

          <div>
            <strong>Contact</strong>
            <div className="list" style={{ marginTop: '.6rem' }}>
              <span>Email: {contactInfo.email}</span>
              <span>WhatsApp: {contactInfo.phone}</span>
              <span>Address: {contactInfo.address}</span>
            </div>
          </div>
        </div>
        <div className="container" style={{ marginTop: '1.2rem', color: 'var(--muted)', fontSize: '.9rem' }}>© <span id="year">{year}</span> Patient Choice. All rights reserved.</div>
      </footer> */}
    </div >
  );
}
